import {useMutation, useQuery, useQueryClient} from '@tanstack/vue-query';
import axios from 'axios';
import {computed, ref} from "vue";
import {errorToast, successToast} from "@/composables/useToasts";

const perPage = ref(30);
const currentPage = ref(1);

export const useKitPages = (websiteId) => {
   const query = useQuery({
    queryKey: ['kit-pages', websiteId, currentPage, perPage],
    queryFn: async () => {
      const queryString = new URLSearchParams({
        websiteId: websiteId,
        page: currentPage.value,
        perPage: perPage.value,
      });

      const { data } = await axios.get(`/ajax/v2/kit/pages?${queryString.toString()}`);

      return data;
    },
  });

  const queryMeta = computed(() => {
    return query?.data?.value?.meta ?? {};
  });

  const handleLoadMore = async () => {
    if (query.hasNextPage.value && !query.isFetchingNextPage.value) {
      await query.fetchNextPage();
    }
  };

  const kitPages = computed(() => {
    return query?.data?.value?.data ?? [];
  });

  const queryClient = useQueryClient();

  const implementFixesMutation = () => useMutation({
    mutationFn: (pageId) => axios.post(`/ajax/v2/kit/page/${pageId}/optimise`),
    onError: () => errorToast('Something went wrong'),
    onSuccess: () => successToast('Fixes scheduled! Kit will start working on this page soon.'),
    onSettled: () => {
      queryClient.invalidateQueries({queryKey: ['kit-pages']});
    },
  });

  return {
    ...query,
    currentPage,
    queryMeta,
    kitPages,
    handleLoadMore,
    implementFixesMutation,
  };
};

export const handlePageChange = (page) => {
  currentPage.value = page;
};
